import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import './scoreboard.css'
import StringToHtml from '../../StringToHtml';
import MobileLiveStreamTabNew from './MobileLiveStreamTabNew';

function ScoreboardNew({scoreboardData, receivedBetlistData,eventId,url,scoreUrl,isvirtual}) {
  const spId = scoreboardData?.sportId;
  const evId = scoreboardData?.eventId;
 
  const [eventName, setEventName] = useState("");
  const [competitionName, setCompetitionName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [matchStatus, setMatchStatus] = useState('');
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
    callAPI();
    }
  
    
  },[scoreboardData]);


  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
  
    useLayoutEffect(() => {
      const updateWidth = () => setWidth(window.innerWidth);
      window.addEventListener("resize", updateWidth);
      return () => window.removeEventListener("resize", updateWidth);
    }, []);
  
    return width;
  };

  const checkScoreShow = () => {
          if (spId != "99994") {
              return true;
          }else{
              return false;
          }
      }

  const callAPI =()=>{
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    fetch(`${process.env.REACT_APP_BASE_URL}/getmatchdata?matchId=${eventId}`, requestOptions)
    .then(async (response) => {
      let paresData = await response.json();
      setCompetitionName(paresData.match.competitionName);
      setEventName(paresData.match.eventName);
      setEventDate(paresData.match.openDate);
      setMatchStatus(paresData.match.status);
    })
    .catch((error) => {
      console.log(error);
    });
  }


  const getIframe = (url) => {    
      return <StringToHtml htmlString={url}  />
  }
  const width = useWindowWidth();

  return (
    <div className='live-score'>
      <div className="heading">
        <div className="heading-text sport-name"><span className='series-name'>{competitionName}</span> <span className='seprator'>/</span> <strong>{eventName}</strong></div>
        <div className="heading-text time"><i className="fa-regular fa-clock"></i> {eventDate && (
          <>
            {new Date(eventDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
            {" at "}
            {new Date(eventDate).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              hour12: false,
            })}
          </>
        )}</div></div>
      {matchStatus == 'IN_PLAY' && checkScoreShow() ? <div className={isvirtual ? 'scoreboard open' : 'scoreboard'}>
        {getIframe(scoreUrl)}
      </div> : ''}
      {<MobileLiveStreamTabNew matchStatus={matchStatus} spId={spId} evId={evId} receivedBetlistData= {receivedBetlistData} url={scoreUrl} tvUrl={url} width={width} isvirtual={isvirtual} />}
    </div>
  )
}

export default ScoreboardNew